/**
 * Scope-aware step plan for AiWarden Intelligence Ask loading UX.
 * Simulated progress only — no backend stats or fake counts.
 */

export const ACCURACY_ASK_STEP_IDS = {
    VDR: 'vdr',
    IRL: 'irl',
    OBSERVATIONS: 'observations',
    RESPONSE: 'response',
};

const VDR_STEP = {
    id: ACCURACY_ASK_STEP_IDS.VDR,
    label: 'Checking VDR',
    shortLabel: 'VDR',
    icon: 'folder',
    description: 'Reviewing relevant documents in the data room',
    durationMs: 3200,
    activeMessages: [
        'Reviewing relevant documents in the data room',
        'Searching document chunks in the data room',
        'Matching permitted files in your scope',
    ],
};

const IRL_STEP = {
    id: ACCURACY_ASK_STEP_IDS.IRL,
    label: 'Checking IRL',
    shortLabel: 'IRL',
    icon: 'checklist',
    description: 'Cross-referencing management responses',
    durationMs: 2800,
    activeMessages: [
        'Cross-referencing management responses',
        'Reviewing information request list items',
        'Loading indexed response matches',
    ],
};

const OBSERVATIONS_STEP = {
    id: ACCURACY_ASK_STEP_IDS.OBSERVATIONS,
    label: 'Checking Observations',
    shortLabel: 'Observations',
    icon: 'warning',
    description: 'Assessing identified risks and inconsistencies',
    durationMs: 2600,
    activeMessages: [
        'Assessing identified risks and inconsistencies',
        'Including observation context where relevant',
        'Checking saved diligence notes',
    ],
};

const RESPONSE_STEP = {
    id: ACCURACY_ASK_STEP_IDS.RESPONSE,
    label: 'Generating Response',
    shortLabel: 'Response',
    icon: 'sparkles',
    description: 'Building grounded consultant answer',
    durationMs: 3600,
    activeMessages: [
        'Building grounded consultant answer',
        'Applying evidence checks and citations',
        'Finalizing consultant response',
    ],
};

/**
 * Build ordered loader steps: VDR? → IRL? → Observations? → Generating Response.
 * Source steps omitted when explicitly disabled in scope.
 */
export function buildAccuracyAskSteps(scope = {}) {
    const steps = [];
    if (scope.includeVdr !== false) {
        steps.push(VDR_STEP);
    }
    if (scope.includeIrl !== false) {
        steps.push(IRL_STEP);
    }
    if (scope.includeObservations !== false) {
        steps.push(OBSERVATIONS_STEP);
    }
    steps.push(RESPONSE_STEP);
    return steps;
}

export function pickAccuracyAskMessage(step, tick = 0) {
    const msgs = step?.activeMessages || [];
    if (!msgs.length) return step?.description || step?.label || 'Processing…';
    return msgs[tick % msgs.length];
}
